import type React from "react";
import { ReactComponent as Svg } from "./assets/style-two-pin-off-map.svg";
import * as styles from "./Icon.module.scss";

type LocationBlockProps = React.SVGProps<SVGSVGElement>;

export const LocationBlock = ({ className, ...props }: LocationBlockProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
